import React from 'react';
import Header from './Header';
import Toggle from './Toggle';

// Example: Customising The Header Decorator To Include Icons
const Container = (props) => {
	const { style, node, onClick, decorators } = props;


	return (
		<div className={`node_container ${node.className}`}>
			<div className="right_side">
				{node.children.length !== 0 && <Toggle {...{ onClick, style, node }} />}
				<Header {...{ onClick: decorators.onSelect, style, node }} />
			</div>
			<div className="left_side">{node.component !== undefined && node.component()}</div>
		</div>
	);
};

export default Container;
